/* eslint-disable max-len */
import React, {useState, useEffect} from 'react'
import {connect} from 'react-redux'

// import {Link} from 'react-router-dom'
import {Avatar, StandardChat} from '@lazarusai/forms-ui-components-test'

// import Chat from './Chat.jsx'

import '../styles/ChatFeed.css'

function ChatFeed(props) {
  const [time, setTime] = useState(0)

  useEffect(() => {
    setTime(props.chatFeedTime)
  }, [props.chatFeedTime])

  return (
    <div
      className='chat-feed'
    >
      <div style={{display: 'none'}}>{time}</div>
      {props.chatFeed?.length > 0 &&
      <StandardChat
        chatFeed={props.chatFeed}
        theme={props.theme}
        paddingBottom={'12em'}
        answerAvatar={
          <Avatar
            theme={props.theme}
            name={'Alfred'}
            size={'small'}
            showGradient={true}
            color={1}
            showText={true}
          />
        }
        userAvatar={
          <Avatar
            theme={props.theme}
            name={''}
            size={'small'}
            color={2}
            showGradient={true}
            showText={false}
          />
        }
      />
      }
    </div>
  )
}


const mapStateToProps = (state, ownProps) => ({
  isLoading: state.userReducer.isLoading,
  userId: state.userReducer.userId,
  theme: state.userReducer.theme,
  chatFeed: state.userReducer.chatFeed,
  chatFeedTime: state.userReducer.chatFeedTime,
})

export default connect(
    mapStateToProps,
    {},
)(ChatFeed)
